import type { KeyboardEvent } from 'react';

export function handleEnterKey(
  event:
    | KeyboardEvent
    | KeyboardEvent<HTMLSpanElement>
    | KeyboardEvent<HTMLDivElement>,
  action?: (event?: any) => void
) {
  const enterKey = event.key === 'Enter';

  if (enterKey) {
    action?.(event);
  }
}

export const fakeButtonProps = { role: 'button', tabIndex: 0 };
